import { createFileRoute } from "@tanstack/react-router";
import { HistoryListPage } from "../../../components/system/HistoryListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/history/")({
  beforeLoad: requireSuperAdmin(),
  component: HistoryRoute,
});

function HistoryRoute() {
  return <HistoryListPage />;
}
